module.exports = __webpack_public_path__ + "img/edit.a3f29659.svg";